import Vue from "vue";

/**
 * 用户验证服务
 */
export default {
  /**
   * 登录接口（获取token)
   * @param {*} params
   * @param {*} config
   */
  async sign(params = {}, config = {}) {
    // config.params = params;
    let result = await Vue.http.post(
      "/lw-authz-server/oauth/token",
      params,
      config
    );
    return result;
  },
  /**
   * 获取用户信息
   * @param {*} params
   * @param {*} config
   */
  async getAuthInfo(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get(
      "/lw-garden-server/account/auth-info",
      config
    );
    return result;
  },
  async getAuthDetailInfo(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get(
      `/lw-garden-server/account/${params}`,
      config
    );
    return result;
  },

  async getUserInfo(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get(
      `/lw-garden-server/account/realInfo`,
      config
    );
    return result;
  },
  /**
   * 获取学生信息
   * @param {*} params
   * @param {*} config
   */
  async getStudentAuthInfo(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get(
      "/lw-garden-server/student/info/by-token",
      config
    );
    return result;
  },

  /**
   * 绑定钉钉账号接口
   * @params {number} code  短信验证码
   * @params {number} phoneNumber  验证手机号
   * @params {number} dingTalkOpenId  钉钉openid
   * @parans {string} realName  证实姓名
   */
  async bingAccount(params = {}, config = {}) {
    let result = await Vue.http.post(
      "/lw-authz-server/oauth/bind/DingTalkOpenId",
      params,
      config
    );
    return result;
  },
  // 发送短信验证码
  async sendVerificationCode(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get(
      "/lw-garden-server/account/verificationCode/send",
      config
    );
    return result;
  },
  /**检测数据库是否有该手机号*/
  async testingPhone(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get(
      "/lw-garden-server/account/validate/cellphone",
      config
    );
    return result;
  },
};
